import { MutableRefObject, useEffect } from 'react';

type Props = {
    prevParentalRatingChannelId: MutableRefObject<string | undefined>;
    visible: boolean;
};

const useResetPrevChannelOnPlayerExit = ({
    prevParentalRatingChannelId,
    visible,
}: Props) => {
    useEffect(() => {
        if (!visible) {
            prevParentalRatingChannelId.current = undefined;
        }
    }, [visible]);
};

export default useResetPrevChannelOnPlayerExit;
